import React from "react";
import { HashRouter as Router, Route, Switch, Redirect} from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import './App.css';
import './Fonts.css';

// components
import PageLayout from "./layout/Layout";

// pages
import Error from "../pages/error/Error";
import Login from "../pages/login/Login";
import Signup from "../pages/signup/Signup"
import ResetPassword from "../pages/resetPassword/ResetPassword"
// context
import { useUserState } from "../context/UserContext";

export default function App() {
    // global
    sessionStorage.setItem('server_api_url', process.env.REACT_APP_API_URL)
    var { isAuthenticated } = useUserState();
    window.isMobile425 = useMediaQuery({maxWidth: '425px' });
    window.isMobileView = useMediaQuery({maxWidth: '650px' });
    window.isIpadView = useMediaQuery({maxWidth: '1024px' });
    window.isLaptopLowView = useMediaQuery({maxWidth: '1376px' });
    window.isIphoneFive= useMediaQuery({maxWidth: '345px' });
    window.isLaptopView = useMediaQuery({maxWidth: '1736px' });
    window.isMinimumLaptop = useMediaQuery({minWidth: '1736px' });
    window.isWidth1600 = useMediaQuery({maxWidth:'1600px'});

    return (
        <Router>
            <Switch>
                 <Route exact path="/" render={() => <Redirect to="/app/corporateDashboard" />} />
                 <PrivateRoute path="/app" component={PageLayout} />
            
                <PublicRoute path="/resetpassword" component={ResetPassword} />
                <PublicRoute path="/login" component={Login}/>
                <PublicRoute path="/signup" component={Signup} />
                <Route component={Error} />
            </Switch>
        </Router>
    );

    // #######################################################################

    function PrivateRoute({ component, ...rest }) {
        return (
            <Route
                {...rest}
                render={props =>
                    isAuthenticated ? (
                        React.createElement(component, props)
                    ) : (
                            <Redirect
                                to={{
                                    pathname: "/login",
                                    state: {
                                        from: props.location,
                                    },
                                }}
                            />
                        )
                }
            />
        );
    }

    function PublicRoute({ component, ...rest }) {
        return (
            <Route
                {...rest}
                render={props =>
                    isAuthenticated ? (
                        <Redirect
                            to={{
                                pathname: "/",
                            }}
                        />
                    ) : (
                            React.createElement(component, props)
                        )
                }
            />
        );
    }
}
